import { TFunction } from "i18next";
import { AssignBoxType } from "../AssignBox/AssignBox";

export const initMoreItemName = (
  entries: { id: any; name: string }[] | undefined,
  type: AssignBoxType,
  isSingularType: boolean, // to use 'kein'
  t: TFunction
) => {
  const baseStr = isSingularType ? "NoAssignItemLabelKein" : "NoAssignItemLabelKeine";
  let itemName: string = t(baseStr, { type: t(type) });

  if (!entries?.length) return itemName;

  itemName = `${entries[0].name}`;
  if (entries.length > 1)
    itemName = itemName + t("_infoBoxMoreItemLabel", { length: entries.length - 1 });

  return itemName;
};

export const initImageLabel = (count: number, t: TFunction) => {
  if (count === 0) {
    return t("NoAssignItemLabelKeine", { type: t("Images") });
  }
  const suffix = count === 1 ? t("Image") : t("Images");
  return `${count} ${suffix}`;
};
